import React from 'react';

const Mission = () => {
  return (
    <section className="mission-section">
      <div className="container">
        <div className="mission-content">
          <p className="mission-label">( Our Mission )</p>
          <h2 className="mission-title">
            We combine refined aesthetic sensibility with a constant pursuit of innovation
          </h2>
          <p className="mission-description">
            We are a graphic design agency dedicated to creating contemporary, high-impact branding solutions. 
            We help brands differentiate themselves, stand out, and build lasting recognition in an increasingly competitive market, 
            through designs that connect, communicate, and endure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Mission;
